export const HOW_TO_IMPORT_SOCIAL_FEEDS_OR_REVIEWS = 'https://help.feedspace.io/en/article/how-to-import-social-feeds-or-reviews-in-feedspace-1nh738y/';